<template>
  <div class="room">
    <!-- <NonServiceHour v-if="!isService" /> -->
    <div class="body">
      <div v-for="m in lastClientChatRoomInfo?.messages" :key="m.id">
        <MessageText
          v-if="
            (m.type === 'Text' || m.type === 'Problem') &&
            !m.isHidden &&
            !m.isTemp
          "
          :message="m"
          :user="getUser(m.fromUserId)"
        />
        <MessageImage
          v-if="m.type === 'Files' && !m.isHidden"
          :message="m"
          :user="getUser(m.fromUserId)"
          :customer="customer"
        />
      </div>
    </div>
    <!---->
    <div class="footer" v-if="isService">
      <div class="end">
        <p>{{ $t("GPT.HISTORY.CLOSE") }}</p>
        <el-button type="primary" @click="continueChat" :loading="loading">
          {{ $t("GPT.HISTORY.CONTINUE") }}
        </el-button>
        <el-button
          type="primary"
          plain
          @click="createBotRoom"
          :loading="gpt_loading"
        >
          {{ $t("GPT.HISTORY.RESTART") }}
        </el-button>
      </div>
    </div>
    <div class="footer" v-else>
      <div class="end">
        <p>{{ $t("GPT.HISTORY.CLOSE") }}</p>
        <el-button type="primary" @click="createBotRoom">
          {{ $t("GPT.HISTORY.RESTART") }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
// import NonServiceHour from "@/components/layout/NonServiceHour";
import MessageText from "@/components/chat/message_text";
import MessageImage from "@/components/chat/message_image";
// import MessageSystem from "@/components/chat/message_system";
import { Customer } from "@/api/customer";
import { languages } from "@/plugins/languages";

export default {
  name: "history",
  components: {
    MessageText,
    MessageImage,
    // NonServiceHour,
    //  MessageSystem,
  },
  data() {
    return {
      // id: this.$route.params.id,
      loading: false,
      showNonService: true,
    };
  },

  mounted() {
    const countryId = this.config.countryId.toUpperCase();
    const lang = languages.includes(countryId) ? countryId : "TW";
    this.$i18n.locale = lang;
  },
  methods: {
    getUser(fromUserId) {
      const user = this.lastClientChatRoomInfo?.users.find(
        (el) => el.id === fromUserId
      );
      return user;
    },
    async isRoomSkillServie() {
      const skill = this.lastClientChatRoomInfo?.users.find(
        (user) => user.isCustomer
      ).product;

      const countryId = this.config.countryId.toUpperCase();
      try {
        const res = await Customer.GetCountryAllSkill({ countryId });
        const ta = res.data.find((el) => el.skillName_Global === skill);
        if (ta) {
          // console.log(skill, ta.isSkillService ? "有營業" : "未營業");
          this.isNonServie = !ta.isSkillService;
          return ta.isSkillService ? skill : "";
        } else {
          console.log("no skill");
          return "";
        }
      } catch (error) {
        console.log("catch", error);
        return "";
      }
    },
    async continueChat() {
      this.loading = true;
      const url = process.env.VUE_APP_URL;
      const { countryId } = this.config;
      const skill = await this.isRoomSkillServie();
      window.open(`${url}?country=${countryId}&skill=${skill}`, "_blank");
      this.loading = false;
    },
    createBotRoom() {
      this.$store.dispatch("gpt/createRoom");
    },
  },
  computed: {
    gpt_loading() {
      return this.$store.state.gpt.loading;
    },
    config() {
      return this.$store.state.global.config;
    },
    beforeChat() {
      return this.$store.state.gpt.beforeChat;
    },
    lastClientChatRoomInfo() {
      return this.$store.state.global.lastClientChatRoomInfo;
    },
    isService() {
      if (this.beforeChat) {
        // 等 beforeChat 拿到資料
        const { isSingleServiceTime, isServiceTime } = this.beforeChat;
        if (
          (isSingleServiceTime && isServiceTime) ||
          (!isSingleServiceTime && this.isRoomSkillServie())
        ) {
          // 是單一服務時間的話，看 isServiceTime
          // 非單一服務時間的話，看 skill 是否服務
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    customer() {
      return this.lastClientChatRoomInfo?.users.find((user) => user.isCustomer);
    },
  },
};
</script>

<style lang="scss" scoped>
.room {
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
  .non-service {
    font-size: 14px;
    color: #333;
    user-select: none;
    .non-service-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 8px;
      box-shadow: 0px 2px 6px 0px #a8a8a81a;
      i {
        cursor: pointer;
        font-size: 20px;
      }
    }
    .non-service-content {
      padding: 8px 16px;
      box-shadow: 0px 4px 6px 0px #5252521a;
    }
  }
  .body {
    flex: 1;
    padding: 10px 15px 10px 10px;
  }
  .footer {
    position: sticky;
    z-index: 1;
    bottom: 0;
    box-shadow: 4px 1px 12px 0px #0000001a;
    background-color: #fff;

    .end {
      width: 100%;
      background-color: #fff;
      position: sticky;
      bottom: 0;
      padding: 8px;
      display: flex;
      flex-direction: column;
      p {
        color: #666;
        text-align: center;
        font-size: 12px;
      }
      .el-button {
        width: 100%;
        margin: 0;
        margin-top: 8px;
      }
    }
  }
}

@media (max-width: 1024px) {
  // .gpt-footer {
  //   position: fixed;
  //   left: 0;
  // }
}
</style>
